import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="disclosure-popover"
export default class extends Controller {
  static targets = ['button', 'template']

  static values = {
    title: {
      type: String,
      default: 'TKTK'
    }
  }

  show (event) {
    event.preventDefault()

    if (!this.hasTemplateTarget) {
      return
    }

    document.body.dispatchEvent(new CustomEvent('popover:show', {
      detail: { template: this.templateTarget, title: this.titleValue }
    }))
  }
}
